import './Carousel.global.scss';
import arrowLeft56Url from './arrow_left_56.svg';
import arrowRight56Url from './arrow_right_56.svg';

class Carousel {
    private _activeImageIndex = 1;
    private _timeout: ReturnType<typeof setTimeout> | undefined;
    private _images: HTMLImageElement[] = [];
    private _slideDuration: number = 2000;
    private _longSlideDuration = this._slideDuration;
    private _origSlideDuration: number = 2000;
    public container: HTMLDivElement = document.createElement('div');
    private _imageContainer: HTMLDivElement = document.createElement('div');
    private _buttonContainer: HTMLDivElement = document.createElement('div');

    constructor(imgUrls: string[] | undefined, ext?: {duration?: number, pauseDuration?: number}) {
        this._slideDuration = ext?.duration ?? this._slideDuration;
        this._origSlideDuration = this._slideDuration;
        this._longSlideDuration = ext?.pauseDuration ?? this._longSlideDuration;

        // Back button
        const backButton = document.createElement('button');
        const backIcon = document.createElement('img');
        // backButton.classList.add('BackBtn');
        backIcon.src = arrowLeft56Url;
        backButton.appendChild(backIcon);
        backButton.onclick = () => {
            this._slideDuration = this._longSlideDuration;
            this._setActiveImageIndex(this._activeImageIndex - 1);
        }

        // Forward button
        const forwardButton = document.createElement('button');
        const forwardIcon = document.createElement('img');
        // forwardButton.classList.add('ForwardBtn');
        forwardIcon.src = arrowRight56Url;
        forwardButton.appendChild(forwardIcon);
        forwardButton.onclick = () => {
            this._slideDuration = this._longSlideDuration;
            this._setActiveImageIndex(this._activeImageIndex + 1);
        }

        // Button container setup
        this._buttonContainer.classList.add('ButtonContainer');
        this._buttonContainer.appendChild(backButton);
        this._buttonContainer.appendChild(forwardButton);

        // Carousel container setup
        this.container.classList.add('CarouselContainer');
        this._imageContainer.classList.add('ImageContainer');
        if (imgUrls) this.setTrackingImageUrls(imgUrls);
        this.container.appendChild(this._imageContainer);
        this.container.appendChild(this._buttonContainer);

        // Set active image index to start value
        this._setActiveImageIndex(this._activeImageIndex);
    }

    setTrackingImageUrls = (urls: string[]) => {
        this._images.forEach(img => img.remove());
        if (urls.length === 0) console.error('unable to set image urls: empty image url arry provided') 
        this._images = urls.map(url => {
            const img = new Image();
            img.src = url;
            img.classList.add('FadeAnimation');
            img.style.display = 'none';
            // console.log('run set tracking image urls')
            return img;
        })
        this._images.forEach(img => this._imageContainer.appendChild(img));
    }

    private _getActiveSlideIndex = (index: number) => {
        if (index > this._images.length) return 1; 
        if (index < 1) return this._images.length; 
        return index;
    }

    private _startAutoImageChange = () => {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(() => {
            this._slideDuration = this._origSlideDuration;
            this._setActiveImageIndex(this._activeImageIndex + 1);
        }, this._slideDuration);
    }

    private _setActiveImageIndex(index: number) {
        // console.log('set active image index: ', index); 
        this._activeImageIndex = this._getActiveSlideIndex(index);    
        if (!this._images[this._activeImageIndex - 1]) {

            console.warn('Could not automate carousel', this._images);
            return;
        }
        for (let i = 0; i < this._images.length; i++) {
            this._images[i].style.display = i === this._activeImageIndex - 1 ? "block" : "none";  
        }
        this._startAutoImageChange();
    }

    public dispose = () => {
        clearTimeout(this._timeout);
        this._images.forEach(img => img.remove());
        this._buttonContainer.remove();
        this._imageContainer.remove();
        this.container.remove();
    }

    public reset = () => {
        clearTimeout(this._timeout);
        this._activeImageIndex = 1;
        for (let i = 0; i < this._images.length; i++) {
            this._images[i].style.display = i === 0 ? "block" : "none";  
        }
    }

    public start = () => {
        this._startAutoImageChange();
    }

    public pause = () => {
        clearTimeout(this._timeout)
    }

}

export default Carousel;